const mvSwiper = new Swiper('.mv-swiper', {
    loop: false, // 自動でループしない
    slidesPerView: 3.5, // 3枚表示＋4枚目を少し見せる
    spaceBetween: 12.6, // スライド間の余白
    speed: 2500, // スライド切り替え速度（必要なら変更）

    breakpoints: {
        1024: { // 1024px以上の画面幅では3.5枚表示
            slidesPerView: 3.5,
        },
        768: { // 768px以上で2.3枚表示
            slidesPerView: 2.4,
        },
        500: { // 500px以上で2.2枚表示
            slidesPerView: 2.3,
        },
        0: { // 500px以下では1.1枚表示
            slidesPerView: 1.1,
        },
    },
});